import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDataDisplayerPagination } from "../../components/DataDisplayer/DataDisplayer";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { EmptyIssueModel, IIssuesModal } from "./IssuesApp";
import { ISearchParam } from "../BaseApp";

interface IIssuesState {
    issues: IIssuesModal[],
    selectedIssues: IIssuesModal[],
    searchParams: ISearchParam[],
    loading: boolean,
    pagination: IDataDisplayerPagination,
    search?: string 
}

const initialState: IIssuesState = {
    issues: [],
    selectedIssues: [],
    searchParams: [],
    loading: false,
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    }
}

const issuesSlice = createSlice({
    name: "issues",
    initialState,
    reducers: {
        updateAllIssues: (state: IIssuesState, action: PayloadAction<Array<IIssuesModal>>) => {
            state.issues = action.payload
        },
        addNewIssue: (state: IIssuesState, action: PayloadAction<IIssuesModal>) => {
            let issues = state.issues

            if (issues.filter(issue => issue.id === action.payload.id).length === 0){
                // state.transactions.push(action.payload)
                issues = [
                    action.payload,
                    ...issues
                ]
            }

            state.issues = issues

        },
        deleteIssue: (state: IIssuesState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let issues = state.issues

            issues = issues.filter(issue => issue.id !== payload.id)

            state.issues = issues

        },
        updateIssue: (state: IIssuesState, action: PayloadAction<IIssuesModal>) => {
            let issues = state.issues
            
            if (issues && issues.length > 0){
                issues.map((issue) => {
                    if (issue.id === action.payload.id){

                        const issueIndex = issues.findIndex(issue => issue.id === action.payload.id)
                        issues[issueIndex] = action.payload

                    }
                })
            }

            state.issues = issues

        },
        updateIssusesLoadingStatus: (state: IIssuesState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updateIssusesPagination: (state: IIssuesState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updateIssusesSearch: (state: IIssuesState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        updateIssusesSearchParams: (state: IIssuesState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
        setSelectedIssues: (state: IIssuesState, action: PayloadAction<IIssuesModal[]>) => {
            state.selectedIssues = action.payload
        },
    }
})

/**
 * Return all Issuses
 */
export const useReturnAllIssuses = () => useSelector((state: RootState) => state.issues.issues)

/**
 * Retrun single issue
 */
export const useReturnSingleIssue = (id: number) => {
    const issuees = useReturnAllIssuses()

    let issue: IIssuesModal = EmptyIssueModel

    if (issuees.length > 0){
        issuees.map((single) => {
            if (single.id === id){
                issue = single
            }
        })
    }

    return issue

}

/**
 * Return issues loading status
 */
export const useReturnIssuesLoadingStatus = () => useSelector((state: RootState) => state.issues.loading)

/**
 * Return Issues pagination
 */
export const useReturnIssuesPagination = () => useSelector((state: RootState) => state.issues.pagination)

/**
 * Return Issues search
 */
export const useReturnIssuesSearch = () => useSelector((state: RootState) => state.issues.search)

/**
 * Return Issues search params
 */
export const useReturnIssuesSearchParams = () => useSelector((state: RootState) => state.issues.searchParams)

/**
 * Return Selected Issues
 */
export const useReturnSelectedIssues = () => useSelector((state: RootState) => state.issues.selectedIssues)

export const { updateAllIssues, addNewIssue, deleteIssue, updateIssue, updateIssusesLoadingStatus, updateIssusesPagination, updateIssusesSearch, updateIssusesSearchParams, setSelectedIssues } = issuesSlice.actions
export default issuesSlice.reducer